import { LoggingService } from "./../helpers/logging-service";
export class CouchManageTable {
    constructor({ couchDb, secondaryIndexOptions, tableFullName, partitionKeyFieldName, sortKeyFieldName, }) {
        Object.defineProperty(this, "partitionKeyFieldName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sortKeyFieldName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "couchDb", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tableFullName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "secondaryIndexOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.couchDb = couchDb;
        this.tableFullName = tableFullName;
        this.partitionKeyFieldName = partitionKeyFieldName;
        this.sortKeyFieldName = sortKeyFieldName;
        this.secondaryIndexOptions = secondaryIndexOptions;
        this._trickLinter();
    }
    _trickLinter() {
        if (this.partitionKeyFieldName && this.sortKeyFieldName && this.tableFullName) {
        }
    }
    _fuse_getInstance() {
        return this.couchDb();
    }
    async fuse_createIndex({ indexName, fields }) {
        const result = await this._fuse_getInstance()
            .getDocInstance()
            .createIndex({
            index: {
                fields: fields,
            },
            name: indexName,
            ddoc: indexName,
            type: "json",
            partitioned: true,
        });
        LoggingService.log(result);
        return {
            id: result.id,
            name: result.name,
            result: result.result,
        };
    }
    async fuse_clearAllIndexes() {
        const indexes = await this._fuse_getInstance().getIndexes();
        if (indexes?.indexes?.length) {
            const deletedIndexes = [];
            for (const index of indexes.indexes) {
                if (index?.type !== "special") {
                    deletedIndexes.push(index);
                    await this._fuse_getInstance().deleteIndex({
                        ddoc: index.ddoc,
                        name: index.name,
                    });
                }
            }
            return {
                deletedIndexes,
            };
        }
        return {
            deletedIndexes: [],
        };
    }
    fuse_getIndexes() {
        return this._fuse_getInstance().getIndexes();
    }
    fuse_createDatabase() {
        return this._fuse_getInstance().createDatabase();
    }
    async fuse_createDefinedIndexes() {
        const results = [];
        if (this.secondaryIndexOptions?.length) {
            for (const indexOption of this.secondaryIndexOptions) {
                if (indexOption.indexName) {
                    const resultData = await this.fuse_createIndex({
                        fields: [indexOption.partitionKeyFieldName, indexOption.sortKeyFieldName],
                        indexName: indexOption.indexName,
                    });
                    LoggingService.log(resultData);
                    results.push(resultData.result);
                }
            }
        }
        return results;
    }
}
